import { LAYOUTS, ModalAlignmentEnum, POSITION } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackSelfContent, StackType, StackWidth, TextAlignTokens, WIDGET } from "@voltmoney/schema";
import { ROUTE } from '../../../routes';
import { ACTION } from "./types";
import { getStartedClick } from "./action";
export const template = async () => {
    return {
        layout: {
            id: ROUTE.COLLATERAL_INTRO_CARD,
            type: LAYOUTS.MODAL,
            style: {
                isPartnerPlatform: true,
                alignment: ModalAlignmentEnum.CENTER,
            },
            widgets: [{ id: "mainStack", type: WIDGET.STACK }],
        },
        datastore: {
            headerStack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    { id: "headingText", type: WIDGET.TEXT },
                    { id: "cancelIcon", type: WIDGET.ICON }
                ]
            },
            mainStack: {
                type: StackType.column,
                width: StackWidth.CONTENT,
                maxWidth: 488,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR4,
                    borderWidth: {
                        all: SizeTypeTokens.Size1
                    }
                },
                borderRadius: 16,
                padding: {
                    all: SizeTypeTokens.XXXL
                },
                widgetItems: [
                    { id: "headerStack", type: WIDGET.STACK },
                    { id: "space32", type: WIDGET.SPACE },
                    { id: "exploreStack", type: WIDGET.STACK },
                    { id: "space24", type: WIDGET.SPACE },
                    { id: "space2", type: WIDGET.SPACE },
                    { id: "howItWorksText", type: WIDGET.TEXT },
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "howItWorksFullStack", type: WIDGET.STACK },
                    { id: "space32", type: WIDGET.SPACE },
                    { id: "space6", type: WIDGET.SPACE },
                    { id: "getStartedButton", type: WIDGET.BUTTON },
                ]
            },
            headingText: {
                label: "Collaterals",
                fontWeight: '600',
                fontSize: FontSizeTokens.XL,
                lineHeight: 28,
                color: ColorTokens.Grey_Night
            },
            cancelIcon: {
                name: IconTokens.Cancel,
                size: IconSizeTokens.XXL
            },
            accountIcon: {
                name: IconTokens.Account,
                size: IconSizeTokens.XXXXXL
            },
            space32: {
                size: SizeTypeTokens.Size32
            },
            exploreStack: {
                type: StackType.row,
                justifyContent: StackJustifyContent.spaceBetween,
                alignSelf: StackSelfContent.center,
                width: StackWidth.MATCH_PARENT,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR2,
                    borderWidth: {
                        all: SizeTypeTokens.Size1
                    },
                    borderColor: ColorTokens.Grey_Chalk
                },
                bgColor: ColorTokens.Grey_Milk,
                widgetItems: [
                    { id: "exploreHeaderStack", type: WIDGET.STACK },
                    { id: "collateralImageStack", type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM }
                ]
            },
            collateralImageStack: {
                type: StackType.column,
                alignSelf: StackSelfContent.flexEnd,
                padding: {
                    top: SizeTypeTokens.XS
                },
                widgetItems: [
                    { id: "collateralImage", type: WIDGET.IMAGE }
                ]
            },
            howItWorksText: {
                label: 'How it works',
                fontWeight: '600',
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.MD
            },
            exploreHeaderStack: {
                type: StackType.column,
                padding: {
                    all: SizeTypeTokens.XXL
                },
                widgetItems: [
                    { id: "exploreHeading", type: WIDGET.TEXT },
                    { id: "space8", type: WIDGET.SPACE },
                    { id: "explorePoints1", type: WIDGET.TEXT },
                    { id: "explorePoints2", type: WIDGET.TEXT },
                    { id: "explorePoints3", type: WIDGET.TEXT },
                ]
            },
            exploreHeading: {
                label: 'Explore our collaterals',
                fontWeight: '600',
                fontSize: FontSizeTokens.MD,
                lineHeight: 24,
                color: ColorTokens.Grey_Night
            },
            explorePoints1: {
                label: `\u2022 FREE samples`,
                fontWeight: '400',
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            explorePoints2: {
                label: `\u2022 Fully customisable`,
                fontWeight: '400',
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            explorePoints3: {
                label: `\u2022 One click share`,
                fontWeight: '400',
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 18,
                color: ColorTokens.Grey_Charcoal
            },
            howItWorksFullStack: {
                type: StackType.row,
                justifyContent: StackJustifyContent.spaceBetween,
                width: StackWidth.MATCH_PARENT,
                alignContent: StackAlignContent.center,
                widgetItems: [
                    { id: "howItWorksStack1", type: WIDGET.STACK },
                    { id: "dottedLineStack", type: WIDGET.STACK },
                    { id: "howItWorksStack2", type: WIDGET.STACK },
                    { id: "dottedLineStack", type: WIDGET.STACK },
                    { id: "howItWorksStack3", type: WIDGET.STACK },
                ]
            },
            howItWorksStack1: {
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: "accountIcon", type: WIDGET.ICON },
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "howItWorksText1", type: WIDGET.TEXT },
                ]
            },
            howItWorksStack2: {
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: "selectIcon", type: WIDGET.ICON },
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "howItWorksText2", type: WIDGET.TEXT },
                ]
            },
            howItWorksStack3: {
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: "shareIcon", type: WIDGET.ICON },
                    { id: "space16", type: WIDGET.SPACE },
                    { id: "howItWorksText3", type: WIDGET.TEXT },
                ]
            },
            howItWorksText1: {
                label: 'Add your\ncontact details',
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 20,
                textAlign: TextAlignTokens.center,
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                color: ColorTokens.Grey_Night
            },
            howItWorksText2: {
                label: 'Select your\ntemplate',
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 20,
                textAlign: TextAlignTokens.center,
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                color: ColorTokens.Grey_Night
            },
            howItWorksText3: {
                label: 'Save and share to\nyour customers',
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: 20,
                textAlign: TextAlignTokens.center,
                fontSize: FontSizeTokens.SM,
                fontWeight: '500',
                color: ColorTokens.Grey_Night
            },
            selectIcon: {
                name: IconTokens.SelectIcon,
                size: IconSizeTokens.XXXXXL
            },
            shareIcon: {
                name: IconTokens.ShareIcon,
                size: IconSizeTokens.XXXXXL
            },
            collateralImage: {
                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/collateral_illustrations.png',
                width: 183,
                height: 94
            },
            dottedLineStack: {
                type: StackType.column,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                padding: {
                    top: SizeTypeTokens.XXL
                },
                widgetItems: [
                    { id: "dottedLine", type: WIDGET.DIVIDER }
                ]
            },
            getStartedButton: {
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                label: "Get started",
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.SM,
                action: {
                    type: ACTION.GET_STARTED,
                    routeId: ROUTE.COLLATERAL_INTRO_CARD,
                    payload: {}
                }
            },
            dottedLine: {
                type: 'dashed',
                color: ColorTokens.Grey_Chalk,
                width: 70
            },
            space8: {
                size: SizeTypeTokens.MD
            },
            space24: {
                size: SizeTypeTokens.XXXL
            },
            space2: {
                size: SizeTypeTokens.XS
            },
            space16: {
                size: SizeTypeTokens.XL
            },
            space6: {
                size: SizeTypeTokens.Size6
            }
        },
    };
};
export const collateralIntroCardMf = {
    onLoad: async () => {
        return Promise.resolve(template());
    },
    actions: {
        [ACTION.GET_STARTED]: getStartedClick,
    },
    clearPrevious: false,
};
